import EditItem from './EditItem'
import AdminEditItem from './AdminEditItem'
import ViewItem from './ViewItem'
import { useState } from 'react'

const useDataList = () => {
  const [isOpen, setIsOpen] = useState(true)

  const viewSwitcher = (
    item,
    fieldIndex,
    onEditMode,
    admin,
    classes,
    index,
    formikProps,
    reorderFields,
    toggleIsHidden,
    updateFieldLabel,
    updateDataType,
    isCardDirty,
    toggleDeleteConfirmationModal
  ) => {
    if (onEditMode && !item.isHidden) {
      // if (item.isMandatory) {
      //   return (
      //     <div>
      //       <Text type={'h9'} className={classes.label}>
      //         {item.label} :<span>&nbsp;</span>
      //         {item.fieldData}
      //       </Text>
      //     </div>
      //   )
      // }
      return (
        <EditItem
          key={item.fieldId}
          item={item}
          index={index}
          fieldIndex={fieldIndex}
          formikProps={formikProps}
        />
      )
    } else if (admin) {
      return (
        <AdminEditItem
          key={item.fieldId}
          item={item}
          fieldIndex={fieldIndex}
          updateDataType={updateDataType}
          toggleDeleteConfirmationModal={toggleDeleteConfirmationModal}
          index={index}
          updateFieldLabel={updateFieldLabel}
          toggleIsHidden={toggleIsHidden}
        />
      )
    } else if (!item.isHidden) {
      return <ViewItem key={item.fieldId} item={item} />
    }
  }

  return { viewSwitcher, isOpen, setIsOpen }
}

export default useDataList
